import type { StateCreator } from "zustand";
import type { IState } from "~/lib/stateManagement/persistedState/persistedStore";

export interface IEnvironmentState {
	isMobile: boolean;
	setIsMobile: (isMobile: boolean) => void;
	isDesktop: boolean;
	setIsDesktop: (isDesktop: boolean) => void;
	hasWindow: boolean;
	setHasWindow: (hasWindow: boolean) => void;
}

export const createEnvironmentSlice: StateCreator<IState, [], [], IEnvironmentState> = (
	set,
	_get,
) => ({
	isMobile: false,
	setIsMobile: (isMobile) => set(() => ({ isMobile })),
	isDesktop: false,
	setIsDesktop: (isDesktop) => set(() => ({ isDesktop })),
	hasWindow: false,
	setHasWindow: (hasWindow) => set(() => ({ hasWindow })),
});
